import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/managed-it-services-montclair")({
  beforeLoad: () => {
    throw redirect({ href: "/services/managed-it-services/montclair", statusCode: 301 });
  },
});
